export class JuchuDetailData {
  /*
   * 表示用行NO
   */
  dispNo: string = '';
  /*
   * 行NO
   */
  jyugyoNo: string = '';

  /**
   * 品目
   */
  hinCd: string = '';

  /**
   * 品目名称
   */
  hinNm: string = '';

  /**
   * 品目K区分
   */
  hinKbn: string = '';

  /**
   * カタログ
   */
  irogNm: string = '';

  /**
   * 色グループCD
   */
  irogCd: string = '';

  /**
   * 入目
   */
  irime: string = '';

  /**
   * 入目単位区分
   */
  irimeKbn: string = '';

  /**
   * 入目単位
   */
  irimeNm: string = '';

  /**
   * 艶区分
   */
  tuyaCd: string = '';

  /**
   * 艶
   */
  tuyaNm: string = '';

  /**
   * サイズ
   */
  hinSize: string = '';

  /**
   * 形状
   */
  hinShape: string = '';

  /**
   * 目地
   */
  hinJoint: string = '';

  /**
   * サイズ
   */
  hinSizeNm: string = '';

  /**
   * 形状
   */
  hinShapeNm: string = '';

  /**
   * 目地
   */
  hinJointNm: string = '';

  /**
   * 表示色調
   */
  hyoujiIroCd: string = '';

  /**
   * 基本色調
   */
  kihonIroCd: string = '';

  /**
   * 数量
   */
  jyuSu: string = '';

  /**
   * 数量単位
   */
  nisugataKbn: string = '';

  /**
   * 数量単位名称
   */
  nisugataNm: string = '';

  /**
   * 回答納期
   */
  kaitoDt: string = '';

  /**
   * 回答納期_AM/PM区分
   */
  kaitoKbn: string = '';

  /**
   * 回答納期_AM/PM
   */
  ampmNm: string = '';

  /**
   * 回答状況区分
   */
  kaijyoKbn: string = '';

  /**
   * 回答状況
   */
  kaitoNm: string = '';

  /**
   * 配送業者CD
   */
  haiCd: string = '';

  /**
   * 配送業者支店CD
   */
  haiCd2: string = '';

  /**
   *  配送業者名
   */
  haiNm: string = '';

  /**
   *  支店名略名
   */
  haiShitenNm: string = '';

  /**
   * 追跡用URL前
   */
  haiUrlMae: string = '';

  /**
   * 追跡用URL後
   */
  haiUrlAto: string = '';

  /**
   * 送り状NO
   */
  okuriNo: string = '';

  /**
   * 出荷日
   */
  syukkaDt: string = '';

  /**
   * 見本板管理NO
   */
  mihonNo: string = '';

  /**
   * 現物色依頼区分
   */
  geniraiKbn: string = '';

  /**
   * 現物管理No
   */
  genbutuNo: string = '';

  /**
   * 備考
   */
  biko: string = '';

  /**
   * 色備考
   */
  iroBiko: string = '';

  /**
   * 固定色調区分
   */
  iroKbn: string = '';

  /**
   * セット区分
   */
  setKbn: string = '';

  /**
   * 操作区分
   */
  processKbn: string = '';

  /**
   * 員数
   * （セットバラシで使用）
   */
  inzu: string = '';

  /**
   * セットバラシ区分
   * （セットバラシで使用）
   */
  barashiKbn: string = '';

  static FIELD_KEY_NAME = {
    dispNo: 'dispNo',

    jyugyoNo: 'jyugyoNo',

    hinCd: 'hinCd',

    hinNm: 'hinNm',

    hinKbn: 'hinKbn',

    irogNm: 'irogNm',

    irogCd: 'irogCd',

    irime: 'irime',

    irimeKbn: 'irimeKbn',

    irimeNm: 'irimeNm',

    tuyaCd: 'tuyaCd',

    tuyaNm: 'tuyaNm',

    hinSize: 'hinSize',

    hinShape: 'hinShape',

    hinJoint: 'hinJoint',

    hyoujiIroCd: 'hyoujiIroCd',

    kihonIroCd: 'kihonIroCd',

    jyuSu: 'jyuSu',

    nisugataKbn: 'nisugataKbn',

    nisugataNm: 'nisugataNm',

    kaitoDt: 'kaitoDt',

    kaitoKbn: 'kaitoKbn',

    ampmNm: 'ampmNm',

    kaijyoKbn: 'kaijyoKbn',

    kaitoNm: 'kaitoNm',

    haiCd: 'haiCd',

    haiCd2: 'haiCd2',

    haiNm: 'haiNm',

    haiUrlMae: 'haiUrlMae',

    haiUrlAto: 'haiUrlAto',

    okuriNo: 'okuriNo',

    syukkaDt: 'syukkaDt',

    mihonNo: 'mihonNo',

    geniraiKbn: 'geniraiKbn',

    genbutuNo: 'genbutuNo',

    biko: 'biko',

    iroBiko: 'iroBiko',

    iroKbn: 'iroKbn',

    setKbn: 'setKbn',

    processKbn: 'processKbn',

    inzu: 'inzu',

    barashiKbn: 'barashiKbn',
  };
}
